import { useClientConfigProvider } from "@/app/config/client-config-provider";
import RegisterLoginLayoutV1 from "./v1/v1";
import RegisterLoginLayoutV2 from "./v2/v2";
import { ReactNode } from "react";

function RegisterLoginLayout({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  const { config } = useClientConfigProvider();
  if (config?.designVersion === "v1") {
    return <RegisterLoginLayoutV1>{children}</RegisterLoginLayoutV1>;
  }
  if (config?.designVersion === "v2") {
    return <RegisterLoginLayoutV2>{children}</RegisterLoginLayoutV2>;
  }
}

export default RegisterLoginLayout;
